import React, { useState } from 'react';
import { useParams, useNavigate, useOutletContext, Link } from 'react-router-dom';

import { db } from './firebase'

import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { useDocument } from 'react-firebase-hooks/firestore';

import { MAX_MEMBERS } from './members';

export default function Join() {
    const { uid } = useOutletContext();
    const { huntId } = useParams();
    const navigate = useNavigate();

    const huntRef = doc(db, "hunts", huntId);
    const [hunt, loading, error] = useDocument(huntRef);
    const [busy, setBusy] = useState(false);

    if (loading) {
        return <p>Loading…</p>;
    }
    if (error || !hunt.exists()) {
        return <p>This invite link is invalid, or the hunt no longer exists. <Link to="/">Home</Link></p>;
    }

    const data = hunt.data();
    const members = data.memberIds ?? [];
    const alreadyMember = members.includes(uid);
    const atCap = !alreadyMember && members.length >= MAX_MEMBERS;

    async function join() {
        if (busy) return;
        setBusy(true);
        // arrayUnion only adds the uid if it isn't already present.
        await updateDoc(huntRef, { memberIds: arrayUnion(uid) });
        navigate("/play/" + huntId);
    }

    return (
        <div>
            <h1>Join “{data.displayName}”?</h1>
            {alreadyMember ? (
                <p>
                    You're already in this hunt.{" "}
                    <button onClick={() => navigate("/play/" + huntId)}>Go to hunt</button>
                </p>
            ) : atCap ? (
                <p>This hunt is full ({MAX_MEMBERS} members). Ask the owner to remove someone, or start your own.</p>
            ) : (
                <button disabled={busy} onClick={join}>Join hunt</button>
            )}
        </div>
    );
}
